import {action, makeAutoObservable} from "mobx";
import {DrillType} from "../util/GCodeSettingBuilder";
import localStorage from "../util/localstorage";
import localstorage from "../util/localstorage";

const PARAM_NAME = "sdfkeguh4iefoq3uerwhto_v1"

export type ToolSet = {
    cutters: Array<number>,
    engravings: Array<number>,
    drills: Array<number>,
}

export type GCodeParameters = {
    plateThickness: number
    millingDepth: number
    millingSpeed: number
    moveHeight: number
    toolChangeHeight: number
    offsetOnDrillCutDepth: number
    holeDiameterOffset: number
    skipFirstN: number
    drillType: DrillType
    useSeparateFiles: boolean
    cutStep: number
    bridgeHeightPercentage: number,
    toolSet: ToolSet,
}

class GCodeParametersStore {
    private parameters: GCodeParameters = {
        plateThickness: 1.5,
        millingDepth: 0.07,
        millingSpeed: 50,
        moveHeight: 2,
        toolChangeHeight: 20,
        offsetOnDrillCutDepth: 0.01,
        holeDiameterOffset: 0.1,
        skipFirstN: 0,
        drillType: DrillType.MILLING,
        useSeparateFiles: true,
        cutStep: 0.5,
        bridgeHeightPercentage: 70,
        toolSet: {
            cutters: [0.5, 1.5],
            engravings: [],
            drills: [],
        },
    }

    constructor() {
        makeAutoObservable(this)
        let storedParameters = localStorage.get(PARAM_NAME)
        if (storedParameters != null) {
            this.parameters = {
                ...this.parameters,
                ...storedParameters,
                holeDiameterOffset: storedParameters.holeDiameterOffset ?? 0.1,
                skipFirstN: storedParameters.skipFirstN ?? 0,
            }
        } else {
            localstorage.put(PARAM_NAME, this.parameters)
        }
    }

    getParameters(): GCodeParameters {
        return this.parameters
    }

    @action
    setParameters(params: GCodeParameters) {
        this.parameters = params
        localstorage.put(PARAM_NAME, this.parameters)
    }

}

export const gCodeParametersStore: GCodeParametersStore = new GCodeParametersStore()